import i18n from '@/localisation/i18n';
import clsx from 'clsx';

export const EmotionLabel = ({
  emotion,
  val,
  isLarge = false,
}: {
  emotion: string;
  val: number;
  isLarge?: boolean;
}) => {
  return (
    <div
      className={clsx(
        'badge badge-outline mb-1 mr-1 border-primary',
        isLarge && 'mr-2 !h-8 !px-3 !text-sm font-semibold'
      )}
    >
      {i18n.t(emotion as never)} {val}
    </div>
  );
};
